<template>
  <div>
    <slot>
      <a href="#" @click.prevent="$bvModal.show(id)" class="text-dark">{{ text || "-" }}</a>
    </slot>
    <b-modal :id="id" size="sm" title="Editar campo" :ok-disabled="loading || newValue === ''" @ok="handleOk">
      <b-form-group :label="getFieldLabel(field)">
        <b-form-input
          v-model="newValue"
          :placeholder="'Ingrese ' + getFieldLabel(field)"
          :disabled="loading"
          @keyup.enter="handleOk"
        ></b-form-input>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ModalEditProductores",
  data() {
    return {
      newValue: this.value || "",
      loading: false
    };
  },
  props: {
    id: {
      type: String | Number,
      default: 0
    },
    text: {
      type: String | Number,
      default: null
    },
    data: {
      type: Object
    },
    field: {
      type: String
    },
    value: [String, Number],
    inputType: {
      type: String,
      default: "text"
    },
    headings: {
      type: Array
    }
  },
  methods: {
    getFieldLabel(field) {
      return this.headings.find((h) => h.key === field).label;
    },
    handleOk(bvModalEvent) {
      if (this.newValue === this.value) {
        return;
      } else {
        bvModalEvent.preventDefault();
        this.updateField();
      }
    },

    async updateField() {
      this.loading = true;
      try {
        const response = await this.$axios.put(`/api/v1/origin/${this.data.id}/update_field/`, {
          field: this.field,
          value: this.newValue
        });
        this.$emit("update", response.data);
        this.$nextTick(() => {
          this.$bvModal.hide(this.id);
        });
      } catch (error) {
        this.$bvToast.toast("Error al actualizar huerto", {
          title: "Error",
          variant: "danger",
          solid: true
        });
        console.log(error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style></style>
